var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBackInStockTick = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 67 67"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2d2d2d",
  fillRule: "evenodd",
  d: "M33.5 62.3c15.9 0 28.7-12.9 28.7-28.7S49.4 4.8 33.5 4.8 4.8 17.7 4.8 33.6a28.64 28.64 0 0 0 28.7 28.7m0 3.8c18 0 32.6-14.6 32.6-32.6S51.5 1 33.5 1 .9 15.6.9 33.6s14.6 32.5 32.6 32.5m13.2-44.5c.8-.7 2-.7 2.7.1s.7 2-.1 2.7L26.8 45.1c-.1.1-.2.2-.4.3a1.9 1.9 0 0 1-2.7-.1L17.6 39c-.7-.8-.7-2 0-2.7.8-.7 2-.7 2.7 0l4.9 5.1z"
})));
export default SvgBackInStockTick;